<script setup lang="ts">
import {useRoute} from "vue-router";
import {Button, Icon} from "@/Components/Library";

const {title = "Launch posts"} = defineProps<{
    title?: string;
}>();
const emit = defineEmits<{
    cancel: any;
}>();

const currentRoute = useRoute();
console.log(currentRoute);
</script>
<template>
    <div class="rounded-md bg-askr-green pl-3 text-white">
        <div class="mb--1 flex items-center gap-2">
            <div class="flex grow items-center py-2">
                <Icon icon="fluent:chat-bubbles-question-32-filled" class="h-6 w-6" />
                <h2 class="ml-2 text-lg font-bold leading-none">{{ title }}</h2>
                <slot name="header"></slot>
            </div>
            <Button icon="mdi:close" class="ml-auto !p-2 text-white" @click="emit('cancel')" />
            <div class="ml-auto flex items-center">
                <!--                <RouterLink-->
                <!--                    v-if="currentRoute.name !== 'questions.launch'"-->
                <!--                    :to="{name: 'questions.launch', query: {...currentRoute.query.question, launch: true}}"-->
                <!--                >-->
                <!--                    <Button :icon="{icon: 'mingcute:send-plane-fill', width: 30}" class="ml-auto text-white">-->
                <!--                        Back to launch-->
                <!--                    </Button>-->
                <!--                </RouterLink>-->
            </div>
        </div>
        <div>
            <slot></slot>
        </div>
    </div>
</template>
<style scoped></style>
